import { useState } from "react";
import { Form, Offcanvas, Spinner, Table } from "react-bootstrap";
import { studyEDCDashboardGraph } from "../../../APIServices/studyEDCDashboardGraph";

const DBPCOMPONENTS = ["Recent activity"];

const AddComponents = ({
  Show,
  Hide,
  studyId,
  category,
  StudyMode,
  selected,
  setSelected,
  getStudyDashboardComponentData,
}) => {
  const [buttonLoader, setButtonLoader] = useState(false);

  const handleCheckbox = (label) => {
    setSelected((prev) =>
      prev.includes(label)
        ? prev.filter((item) => item !== label)
        : [...prev, label]
    );
  };

  const allComponents =
    StudyMode === "Live Mode" ? [...(DBPCOMPONENTS || [])] : "";

  const isAllSelected = selected.length === allComponents.length;

  const toggleSelectAll = () => {
    if (isAllSelected) {
      setSelected([]);
    } else {
      setSelected(allComponents);
    }
  };

  const updateStudyDashboardComponent = async () => {
    setButtonLoader(true);
    let userData = {};
    userData.studyId = studyId;
    userData.category = category;
    userData.components = selected;
    userData.mode = StudyMode;
    let data = await studyEDCDashboardGraph.updateStudyDashboardComponent(
      userData
    );
    if (data?.statusCode === 200) {
      getStudyDashboardComponentData();
      Hide();
    }
    setButtonLoader(false);
  };

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>Component List</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="p-0">
        <Table className="m-0 custom-table" hover striped>
          <thead className="position-sticky top-0">
            <tr>
              <th style={{ width: 45 }} className="text-center">
                <Form.Check
                  type="checkbox"
                  checked={isAllSelected}
                  onChange={toggleSelectAll}
                />
              </th>
              <th>Component Label</th>
            </tr>
          </thead>
          <tbody>
            {StudyMode === "Live Mode" &&
              DBPCOMPONENTS.map((label, index) => (
                <tr key={index}>
                  <td className="text-center">
                    <Form.Check
                      type="checkbox"
                      checked={selected.includes(label)}
                      onChange={() => handleCheckbox(label)}
                    />
                  </td>
                  <td>{label}</td>
                </tr>
              ))}
          </tbody>
        </Table>
      </Offcanvas.Body>

      <div className="text-end p-2 border-top">
        <button
          className="updateProfile"
          onClick={() => updateStudyDashboardComponent()}
          disabled={buttonLoader}
        >
          {buttonLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm" /> Adding...
            </div>
          ) : (
            "Add Component"
          )}
        </button>
      </div>
    </Offcanvas>
  );
};

export default AddComponents;
